function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.90277 0H17.796L26.2201 8.39139V28.0585C26.2201 29.092 25.3821 29.9291 24.3495 29.9291H1.90277C0.870194 29.9291 0.0322266 29.092 0.0322266 28.0585V1.87055C0.0322266 0.837097 0.870291 0 1.90277 0Z",
  fill: "#934CBC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.1932 8.41739H19.6733C18.6407 8.41739 17.8027 7.57943 17.8027 6.54684V0.0185547L26.1932 8.41739Z",
  fill: "#7F3CA6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.45196 13.105H7.15848C6.79277 13.105 6.58887 13.3462 6.58887 13.7129V18.0984C6.58887 18.4894 6.82267 18.7064 7.1369 18.7064C7.45113 18.7064 7.68493 18.4894 7.68493 18.0984V16.818H8.4958C9.49654 16.818 10.3224 16.109 10.3224 14.9689C10.3225 13.8532 9.52567 13.105 8.45196 13.105ZM13.1723 13.105H11.8666C11.5122 13.105 11.2605 13.3482 11.2605 13.7091V18.1022C11.2605 18.5502 11.6225 18.6905 11.8815 18.6905H13.2518C14.8735 18.6905 15.9444 17.6234 15.9444 15.9763C15.9435 14.2348 14.9354 13.105 13.1723 13.105ZM19.204 14.1815C19.5173 14.1815 19.6707 13.9084 19.6707 13.6437C19.6707 13.3697 19.5107 13.105 19.204 13.105H17.4194C17.0706 13.105 16.8761 13.3939 16.8761 13.7129V18.0984C16.8761 18.4894 17.0986 18.7064 17.3998 18.7064C17.6991 18.7064 17.9227 18.4894 17.9227 18.0984V16.8948H19.002C19.3368 16.8948 19.5043 16.6207 19.5043 16.3486C19.5043 16.082 19.3368 15.8173 19.002 15.8173H17.9227V14.1815H19.204ZM12.4391 17.6075H13.235C14.2507 17.6075 14.7146 16.863 14.7146 15.9221C14.7146 14.9167 14.2424 14.1881 13.1564 14.1881H12.4391V17.6075ZM7.68503 15.7893H8.43048C8.89064 15.7893 9.18242 15.4302 9.18338 14.9625C9.18338 14.4939 8.89064 14.1348 8.43048 14.1348H7.68503V15.7893Z",
  fill: "white"
});

var SvgPdf = function SvgPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf.0794be2f.svg";
export { ForwardRef as ReactComponent };